import React, { useState, useEffect } from "react";
import { getProjectFromStorage } from "../../cockpit/fetch";
import { useParams } from "react-router-dom";
import PageComponents from "../../components/cockpit/PageComponents";
import * as Config from '../../config';
import './Project.scss';
import Page404 from "../Page/404";

const Project = () => {
    const [page, setPage] = useState(null);

    const { slug } = useParams();

    useEffect(() => {
        let isCancelled = false;
        getProjectFromStorage(slug, (data) => {
            if (!isCancelled) {
                setPage(data);
            }
        })
        return () => {
            isCancelled = true;
        }
    }, [slug])

    return <>
        {page && <>
            {page === 'error' ? <Page404 /> :
                <div className={`sec-pad thm-container Project project-${page.title.toLowerCase()}`}>
                    <h1>{page.title}</h1>
                    <div className="project-meta">
                        <p className="project-id">{page.project_id}</p>
                        <p className="project-deadline">Deadline: {new Date(page.deadline).toLocaleDateString()}</p>
                    </div>

                    <div className="project-stats">
                        <div className="stat-box">
                            <span className="stat-label">Target</span>
                            <span className="stat-value">${parseInt(page.target).toLocaleString()}</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">Current Balance</span>
                            <span className="stat-value">${parseInt(page.current_balance).toLocaleString()}</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">ROI</span>
                            <span className="stat-value">{page.roi}%</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">My Investment</span>
                            <span className="stat-value">$0</span>
                        </div>
                    </div>

                    <div className="project-progress">
                        <div className="progress-bar">
                            <div className="progress-fill" style={{width: `${(page.current_balance / page.target) * 100}%`}}></div>
                        </div>
                        <p className="progress-text">{Math.round((page.current_balance / page.target) * 100)}% Funded</p>
                    </div>

                    {page.gallery && page.gallery.length > 0 && (
                        <div className="project-gallery">
                            {page.gallery.map((image: { path: string; meta: { title?: string } }, index: number) => (
                                <img key={index} src={Config.COCKPIT_HOST + image.path} alt={image.meta.title || `Gallery ${index + 1}`} />
                            ))}
                        </div>
                    )}

                    <div className="project-description">
                        <p>{page.content}</p>
                    </div>
                </div>
            }</>
        }
    </>
}
export default Project;